import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const pageMeta = {
  '/': {
    title: 'Keystone Strategic Consultants | Delivery Governance & the Videra Platform',
    description: 'Keystone helps organisations manage complex delivery with total clarity and control — powered by the Videra platform. Stage-gated governance, AI insights and audit-ready evidence for NHS, FM and Construction.'
  },
  '/platform': {
    title: 'Videra | Keystone\'s Flagship Platform for Governed Delivery',
    description: 'The unifying platform for governed delivery. One environment. Six outcomes. Stage-gated lifecycle, embedded assurance, AI intelligence, evidence packs, commercial control and portfolio visibility.'
  },
  '/consultancy': {
    title: 'Consultancy | Keystone Strategic Consultants',
    description: 'Specialist consultancy from Keystone — Videra implementation, PFI advisory, lifecycle management, CDM compliance and leadership development. Advisory to Programme engagement.'
  },
  '/sectors': {
    title: 'Sectors | NHS · Hard Services · Construction — Powered by Videra',
    description: 'Three sector-shaped demo workspaces on the Videra platform. NHS Estates Portfolio, Videra Healthcare, and Construction+™ — 14-day trial, no card required.'
  },
  '/sectors/nhs': {
    title: 'NHS Capital & Estates | NHS Estates Portfolio — Videra by Keystone',
    description: 'Multi-Trust NHS portfolio with 16 Trusts, capital programme, lifecycle works, ERIC reporting and Tier-A/B/C compliance packs.'
  },
  '/sectors/hard-services': {
    title: 'Hard Services & FM | Videra Healthcare — PFI Hard Services',
    description: 'PFI hard-services on a single audit-ready framework — 4 healthcare sites, ~50 lifecycle and variation projects, gate documents, board packs, live RAG rollup.'
  },
  '/sectors/construction': {
    title: 'Construction & Capital | Construction+™ Tier-1 Contractor — Videra',
    description: 'Vertically integrated Tier-1 contractor portfolio: 50+ live projects, stage-gated delivery, AI safety, and a 60-year Golden Thread spine.'
  },
  '/about': {
    title: 'About Keystone | Why Delivery Should Never Be Left to Chance',
    description: 'Keystone exists to give leaders visibility, teams clarity and organisations confidence — through governed, evidence-driven delivery powered by the Videra platform. A message from the CEO.'
  },
  '/resources': {
    title: 'Resources | Keystone Insights, Case Studies & Brochures',
    description: 'Read, watch and download — articles on delivery governance, NHS capital, FM assurance, Videra case studies and the launch brochure.'
  },
  '/contact': {
    title: 'Contact Keystone | Book a Videra Demo or Consultancy Call',
    description: 'Book a demo, scope a deployment, or ask anything about governance, assurance and the Videra platform.'
  }
};

const matchMeta = (pathname) => {
  if (pageMeta[pathname]) return pageMeta[pathname];
  if (pathname.startsWith('/sectors/')) return pageMeta['/sectors'];
  return pageMeta['/'];
};

export const SEOHead = () => {
  const location = useLocation();

  useEffect(() => {
    const meta = matchMeta(location.pathname);
    document.title = meta.title;

    const setMeta = (sel, attr, val) => {
      const el = document.querySelector(sel);
      if (el) el.setAttribute(attr, val);
    };

    setMeta('meta[name="description"]', 'content', meta.description);
    setMeta('meta[property="og:title"]', 'content', meta.title);
    setMeta('meta[property="og:description"]', 'content', meta.description);
    setMeta('meta[property="twitter:title"]', 'content', meta.title);
    setMeta('meta[property="twitter:description"]', 'content', meta.description);
    setMeta('link[rel="canonical"]', 'href', `https://keystoneconsulting.uk${location.pathname}`);
  }, [location.pathname]);

  return null;
};

export default SEOHead;
